import { useCallback } from 'react';
import { useUpdateAccountBillingMutation } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';

export function useUpdateTaxId(taxId: string, taxIdType: string) {
  const accountId = useActiveAccountId() ?? '';
  const [updateAccountBilling] = useUpdateAccountBillingMutation();

  const updateTaxId = useCallback(() => {
    if (!taxId || !taxIdType) {
      return;
    }

    updateAccountBilling({
      variables: {
        accountId,
        taxId,
        taxType: taxIdType,
      },
    });
  }, [accountId, taxId, taxIdType, updateAccountBilling]);

  return { updateTaxId };
}
